const changesDates = {
  en: {
    translation: {
      always: "Always",
      last7Days: "Last 7 days",
      last14Days: "Last 14 days",
      last30Days: "Last 30 days",
      last60Days: "Last 60 days",
      last90Days: "Last 90 days",
      yearAgo: "Last year",
      custom: "Custom"
    }
  },
  it: {
    translation: {
      always: "Sempre",
      last7Days: "Ultimi 7 giorni",
      last14Days: "Ultimi 14 giorni",
      last30Days: "Ultimi 30 giorni",
      last60Days: "Ultimi 60 giorni",
      last90Days: "Ultimi 90 giorni",
      yearAgo: "Ultimo anno",
      custom: "Personalizzato"
    }
  }
};

export default changesDates;
